import { useSelector } from 'react-redux'
import { FadeOnMount } from '../../../shared/Animations'
import { SearchCustomModule } from '../SearchCustomModule'
import { selectCustomModules } from '../../../../store/selectors/customerProfile'
import { ListingCardNew, TagPreferenceType } from '../../ListingCardNew/ListingCardNew'
import { ListingCompact } from '../../../../api/gqlaxy/gql/generated/graphql'
import { Flex, Grid } from '@homebotapp/hb-react-component-catalog'
import { HOME_SEARCH_LISTINGS_INDEX_PAGE_LIST_VIEW } from '../../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'

export interface ListViewProps {
  listings: ListingCompact[]
  tagPreference?: TagPreferenceType
}

export const ListView = ({ listings, tagPreference = 'priceChange' }: ListViewProps) => {
  const customModules = useSelector(selectCustomModules)
  const searchCustomModule = customModules?.find((module: any) => module.moduleType === 'search')
  return (
    <>
      <Grid templateColumns={['repeat(1, minmax(200px, 1fr))', null, null, null, 'repeat(2, minmax(200px, 1fr))']} gap={2} px={2} mt={4}>
        {listings?.map((listing, index) => {
          if (index === 2 && searchCustomModule) {
            return (
              <>
                <FadeOnMount key='search-custom-module-card'>
                  <SearchCustomModule />
                </FadeOnMount>
                <FadeOnMount key={listing.id}>
                  <Flex>
                    <ListingCardNew
                      listing={listing}
                      tracking={{
                        guid: '5pPLRccBrshaJr8pBo8rLL',
                        ui_context: HOME_SEARCH_LISTINGS_INDEX_PAGE_LIST_VIEW,
                        descriptor: 'Home Search Map View Listing Clicked'
                      }}
                    />
                  </Flex>
                </FadeOnMount>
              </>
            )
          }
          return (
            <FadeOnMount key={listing.id}>
              <Flex>
                <ListingCardNew
                  listing={listing}
                  tagPreference={tagPreference}
                  tracking={{
                    guid: '5pPLRccBrshaJr8pBo8rLL',
                    ui_context: HOME_SEARCH_LISTINGS_INDEX_PAGE_LIST_VIEW,
                    descriptor: 'Home Search Map View Listing Clicked'
                  }}
                />
              </Flex>
            </FadeOnMount>
          )
        })}
      </Grid>
    </>
  )
}
